import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { history } from "../../utils/History";
import Input from "../../components/forms/Input/index";

import Table from "../../components/table";
import TableStatus from "../../components/table/status";
import SearchButton from "../../components/buttons/SearchButton";
import ResetFilterButton from "../../components/buttons/ResetFilterButton";
import ActiveFilterChips from "../../components/filters/ActiveFilterChips";
import FilteredEmptyState from "../../components/emptyState/FilteredEmptyState";
import HeaderMenu from "../../components/commons/menu/HeaderMenu";
import DetailButton from "../../components/table/detailButton";
import MenuItem from "@material-ui/core/MenuItem";
import { Select } from "@material-ui/core";
import Sidebar from "../../components/layout/index";
import Promo from '../../store/actions/promotion/Index'
import Store from '../../store/actions/store/index';

import PromoModal from "./PromoModal";
import UploadIDModal from "./UploadIDModal";
import UploadVoucherDigitalModal from "./UploadVoucherDigitalModal";
import moment from "moment";
import localization from "moment/locale/id";
import useLatestRequest from "../../components/hooks/useLatestRequest";
import {
  createDetailLocation,
  enumParam,
  hasNonDefaultQuery,
  pageSizeParam,
  positivePage,
  stringParam,
  useListQueryState,
} from "../../utils/listQueryState";
import { quotedSearchLabel } from "../../utils/filterChips";

const PROMO_SORTS = [
  "start_date-desc",
  "start_date-asc",
  "end_date-desc",
  "end_date-asc",
  "created_at-desc",
  "created_at-asc",
  "name-asc",
  "name-desc",
];

const PROMO_QUERY_SCHEMA = {
  page: positivePage,
  length: pageSizeParam,
  search: stringParam(),
  status: enumParam(["all", "active", "upcoming", "ended"], "all"),
  sort: enumParam(PROMO_SORTS, "start_date-desc"),
};

const Index = ({ loggingIn }) => {

    const [dataPromo, setDataPromo] = useState([]);
    const [editPromoModal, setEditPromoModal] = useState(false);
    const [editIdVoucherPromoModal, setEditIdVoucherPromoModal] = useState(false);
    const [editVoucherDigitalPromoModal, setEeditVoucherDigitalPromoModal] = useState(false);
    const [dataPromoRow, setDataPromoRow] = useState([]);
    const { state: query, updateQuery, resetQuery, location } = useListQueryState(PROMO_QUERY_SCHEMA);
    const { page, length, search: searchText, status: statusFilter, sort } = query;
    const hasActiveFilters = hasNonDefaultQuery(
      query,
      PROMO_QUERY_SCHEMA,
      ["search", "status", "sort"]
    );
    const [sortBy, sortDirection] = sort.split("-");
    const [totalData, setTotalData] = useState(null);
    const [maxPage, setMaxPage] = useState(1);
    const [outlet, setOutlet] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [loadError, setLoadError] = useState(null);
    const { beginRequest, isLatestRequest } = useLatestRequest();

    const dispatch = useDispatch();
    const statusOptions = [
      { value: "all", label: "Semua Status" },
      { value: "active", label: "Aktif" },
      { value: "upcoming", label: "Akan Datang" },
      { value: "ended", label: "Berakhir" },
    ];
    const sortOptions = [
      { value: "start_date-desc", label: "Mulai Terbaru" },
      { value: "start_date-asc", label: "Mulai Terlama" },
      { value: "end_date-desc", label: "Berakhir Terlama" },
      { value: "end_date-asc", label: "Segera Berakhir" },
      { value: "created_at-desc", label: "Dibuat Terbaru" },
      { value: "created_at-asc", label: "Dibuat Terlama" },
      { value: "name-asc", label: "Nama A-Z" },
      { value: "name-desc", label: "Nama Z-A" },
    ];

    const resetAllFilters = () => resetQuery(["page", "search", "status", "sort"]);
    const activeFilterChips = [
      searchText && {
        key: "search",
        label: quotedSearchLabel(searchText),
        onRemove: () => updateQuery({ page: 1, search: "" }),
      },
      statusFilter !== "all" && {
        key: "status",
        label: `Status: ${statusOptions.find((option) => option.value === statusFilter)?.label || statusFilter}`,
        onRemove: () => updateQuery({ page: 1, status: "all" }),
      },
      sort !== "start_date-desc" && {
        key: "sort",
        label: `Urutan: ${sortOptions.find((option) => option.value === sort)?.label || sort}`,
        onRemove: () => updateQuery({ page: 1, sort: "start_date-desc" }),
      },
    ].filter(Boolean);
  
    useEffect(() => {
      handleRefresh();
    }, [searchText, statusFilter, sortBy, sortDirection, page, length]);
  
  const handleRefresh = () => {
      const requestId = beginRequest();
      setIsLoading(true);
      setLoadError(null);
      new Promise((resolve, reject) => {
          let param = {
              page: page ? page : 1,
              length,
              search_text: searchText,
              status: statusFilter,
              filter_status: statusFilter,
              sort_by: sortBy,
              sort_direction: sortDirection
          }
          dispatch(Promo.get(param, resolve, reject));
      })
          .then(res => {
              if (!isLatestRequest(requestId)) return;

              setDataPromo(res?.data ?? [])
              setTotalData(res?.totalCount ?? 0)
              const nextMaxPage = Math.max(1, Math.ceil((res?.totalCount ?? 0) / length));
              setMaxPage(nextMaxPage)
              if (page > nextMaxPage) updateQuery({ page: nextMaxPage });
              handleGetTypeStore();
          })
          .catch((error) => {
              if (!isLatestRequest(requestId)) return;

              setLoadError(error?.response?.data?.message ?? "Data promo gagal dimuat.")
          })
          .finally(() => {
              if (isLatestRequest(requestId)) {
                  setIsLoading(false)
              }
          })
  }
const handleSearch = (value) => {
    updateQuery({ page: 1, search: value?.length > 0 ? value : "" })
}
const handleStatusFilter = (event) => {
    updateQuery({ page: 1, status: event.target.value })
}
const handleSort = (event) => {
    updateQuery({ page: 1, sort: event.target.value })
}
  const showEditPromoModal = (data) => {
    setEditPromoModal(!editPromoModal)
    setDataPromoRow(data ? data : [])
  }
  const showEditIdVoucherPromoModal = (data) => {
    console.log("outlet", outlet)
    setEditIdVoucherPromoModal(!editIdVoucherPromoModal)
    setDataPromoRow(data ? data : [])
  }
  const showEditVoucherDigitalPromoModal = (data) => {
    setEeditVoucherDigitalPromoModal(!editVoucherDigitalPromoModal)
    setDataPromoRow(data ? data : [])
  }

  const handleEdit = (param) => {
    const callback = () => {
        handleRefresh()
        setEditPromoModal(!editPromoModal)
    }
    if (param) {
        dispatch(Promo.put(param, callback))
    }
  }

  const handleEditIdVoucher = (param) => {
    const callback = () => {
        handleRefresh()
        setEditIdVoucherPromoModal(!editIdVoucherPromoModal)
    }
    if (param) {
        dispatch(Promo.putIdVoucher(param, callback))
    }
  }

  const handleEditVoucherDigital = (param) => {
    const callback = () => {
        handleRefresh()
        setEeditVoucherDigitalPromoModal(!editVoucherDigitalPromoModal)
    }
    if (param) {
        dispatch(Promo.putVoucherDigital(param, callback))
    }
  }

  
  const handleGetTypeStore = () => {
        new Promise((resolve) => {
            let param = {
                page: 1,
                length: 999
            }
            dispatch(Store.getTypeStore(param, resolve))
        })
        .then(res => {
            let outlets = []
              res?.data?.data.map((item) => {
                outlets = [...outlets, { value: item.id, label: item.name }]
            })
            setOutlet(outlets)
        })
    }

  const columns = [
    {
      Header: "NO",
      accessor: "no",
    },
    {
      Header: "NAMA PROMO",
      accessor: "name",
    },
    {
      Header: "JUMLAH PESERTA",
      accessor: "count_participant",
      Cell: ({ row }) => {
        const { original } = row;
        const {count_participant} = original;
        const count = count_participant + " orang"
        console.log(count_participant)
        return count
      }
    },
    {
      Header: "TGL BROADCAST",
      accessor: "broadcast_at",
      Cell: ({ row }) => {
        const { original } = row;
        const {broadcast_at} = original;
        const tanggal = broadcast_at? moment(broadcast_at).locale("id",localization).format('DD MMMM YYYY') + ', ' + moment(broadcast_at).locale("id", localization).format("LT") : "-"
        return tanggal
      }
    },
    {
      Header: "STATUS",
      accessor: "status",
      Cell: ({ row }) => {
        const { original } = row;
        const { status } = original;
        console.log(status);

        return (
          <TableStatus
            status={
              status === 0 ? 
                "Kadaluarsa" : status === 1 ? 
                "Tersedia" : "Belum Tersedia"
            }
            color={
              status === 0 ? 
                "expired" : status === 1 ? 
                "available" : "notAvailable"
            }
            outline
          />
        );
      },
    },
    {
      Header: "",
      accessor: "actions",
      Cell: ({ row }) => {
        const { original } = row;
        const { id, status } = original;

        return (

          <DetailButton>
            <MenuItem onClick={() => history.push(createDetailLocation(`/promo-detail/${original?.id}`, location))}>
                <span style={{ fontSize: 14 }}>Detail</span>
            </MenuItem>
            { original.status == 2 &&
              <MenuItem onClick={() => showEditPromoModal(original)}>
                <span style={{ fontSize: 14 }}>Edit</span>
              </MenuItem>
            }
              <MenuItem onClick={() => showEditIdVoucherPromoModal(original)}>
                <span style={{ fontSize: 14 }}>Upload ID Promo</span>
              </MenuItem>
              {/* <MenuItem onClick={() => showEditVoucherDigitalPromoModal(original)}>
                <span style={{ fontSize: 14 }}>Upload Voucher Digital</span>
              </MenuItem> */}
          </DetailButton>
        );
        
      },
    },
  ];

  return (
        <div className="menu-container">
          <div>
            <HeaderMenu
              title="Daftar Promo"
              toolbarClassName="page-header-toolbar-split promo-toolbar"
              secondaryContent={hasActiveFilters ? <ActiveFilterChips chips={activeFilterChips} /> : null}
            >
              <div className="toolbar-left">
                <SearchButton
                  placeholder="Cari promo"
                  value={searchText}
                  toggle={(value) => handleSearch(value)}
                />
              </div>
              <div className="toolbar-right">
                <div className="dropdown rounded-button button-white promo-filter-select">
                  <Select
                    value={statusFilter}
                    onChange={handleStatusFilter}
                    inputProps={{
                      name: "promo-status",
                      id: "promo-status"
                    }}
                    disableUnderline
                    style={{ width: "100%" }}
                  >
                    {statusOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                    ))}
                  </Select>
                </div>
                <div className="dropdown rounded-button button-white promo-sort-select">
                  <Select
                    value={sort}
                    onChange={handleSort}
                    inputProps={{
                      name: "promo-sort",
                      id: "promo-sort"
                    }}
                    disableUnderline
                    style={{ width: "100%" }}
                  >
                    {sortOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                    ))}
                  </Select>
                </div>
                <ResetFilterButton
                  visible={hasActiveFilters}
                  onClick={resetAllFilters}
                />
              </div>
            </HeaderMenu>
          </div>
          <div className="content-container-side">
            <div className="overflow">
              <Table
                columns={columns}
                data={dataPromo}
                loading={isLoading}
                error={loadError}
                onRetry={handleRefresh}
                emptyContent={hasActiveFilters ? <FilteredEmptyState onReset={resetAllFilters} /> : null}
                pagination={{
                  page,
                  totalData,
                  maxPage,
                  toggle: (nextPage) => updateQuery({ page: nextPage }),
                  length,
                  onPageSizeChange: (nextLength) => updateQuery({ page: 1, length: nextLength })
              }}
              />
            </div>
          </div>
          {/* Modal */}
          <PromoModal
              show={editPromoModal}
              toggle={showEditPromoModal}
              action={handleEdit}
              data={dataPromoRow}
              // register={() => showRegisterModal(dataPromoRow)}
          />
          <UploadIDModal
              show={editIdVoucherPromoModal}
              toggle={showEditIdVoucherPromoModal}
              action={handleEditIdVoucher}
              data={dataPromoRow}
              outlet={outlet}
          />
          <UploadVoucherDigitalModal
              show={editVoucherDigitalPromoModal}
              toggle={showEditVoucherDigitalPromoModal}
              action={handleEditVoucherDigital}
              data={dataPromoRow}
          />
        </div>

  );
};

export default Index;

